interface Props {
    label: string;
    onDownload: (extension: 'pdf' | 'xlsx') => void;
}

export const ReportItemWithFormats: React.FC<Props> = ({ label, onDownload }) => {
    return (
        <li className='nav-item d-flex align-items-center justify-content-between py-1'>
            <span className="text-muted fs-13">{label}</span>
            <div className="d-flex gap-1">
                <button 
                    onClick={() => onDownload('pdf')}
                    className="btn btn-ghost-danger btn-sm p-1"
                    title="Descargar PDF"
                >
                    <i className="ri-file-pdf-fill fs-18"></i>
                </button>
                <button 
                    onClick={() => onDownload('xlsx')}
                    className="btn btn-ghost-success btn-sm p-1"
                    title="Descargar Excel"
                >
                    <i className="ri-file-excel-fill fs-18"></i>
                </button>
            </div>
        </li>
    );
};